export default class loggerService {
    static logError(error: any, context: string = '') {
        console.log((context? '[context: ' + context + '] ' : '') + this.sanitizeError(error));
    }

    static sanitizeError(error: any):string {
        return (error.Name ? '[name: ' + error.Name + '] ' : '') + (error.Message ? '[msg: ' + error.Message + ']': '');
    }
}